import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface ErrorModalState {
  show: boolean;
  errorMessage: string;
  isHtml?: boolean;
  title: string
}

export interface HtmlError {
  title?: string;
  errorMessage: string;
}

export interface ApiError{
  title?: string;
  errorResponse: any;
}

const initialState: ErrorModalState = {
  show: false,
  errorMessage: "An unexpected error has occurred with your last action. Please try again.",
  title: "An error occurred.",
};

export const errorModalSlice = createSlice({
  name: "errorModal",
  initialState,
  reducers: {
    /** display the given error message */
    showErrorMessage: (
      state,
      action: PayloadAction<ErrorModalState["errorMessage"]>
    ) => {
      state.show = true;
      state.errorMessage = action.payload;
    },
    showHtmlErrorMessage: (
      state,
      action: PayloadAction<HtmlError>
    ) => {
      state.show = true;
      state.errorMessage = action.payload.errorMessage;
      state.title = action.payload?.title ?? initialState.title;
      state.isHtml = true;
    },
    /** convert api response to error message safely */
    showApiErrorMessage: (state, action: PayloadAction<ApiError>) => {
      state.show = true;
      state.errorMessage =
        action.payload?.errorResponse?.response?.data?.[0]?.error?.message ??
        initialState.errorMessage;
      state.title = action.payload?.title ?? initialState.title;
    },
    closeModal: (state) => {
      state.show = false;
    },
  },
});

export const { showErrorMessage, showApiErrorMessage, closeModal, showHtmlErrorMessage } = errorModalSlice.actions;

export const selectErrorModal = (state: RootState) => state.errorModal;

export default errorModalSlice.reducer;
